import React, { useState } from "react";
import { BiMinus, BiPlus } from "react-icons/bi";
import { MdDelete, MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import MasterDeleteModal from "../../UI/Model/MasterDeleteModel/MasterDeleteModel";
import Table from "../../UI/Table/Table";

function BillingTable({
  billingFormData,
  storeData,
  setStoreData,
  TotalPrice,
  errors,
  touched,
  alldata,
}) {
  const [idStore, setIdStore] = useState(false);
  const [message, setMessage] = useState(false);
  const navigate = useNavigate();
  const Thead = [
    { title: "s.nO", with: "10%" },
    { title: "name", with: "10%" },
    { title: "quantity", with: "10%" },
    { title: "unit", with: "10%" },
    { title: "price", with: "10%" },
    { title: "total", with: "10%" },
    { title: "action", with: "10%" },
  ];
  // const TotalPrice = () => {
  //   let total = 0;

  //   storeData?.map((val, i) => {
  //     total = total + Number(val.total);
  //   });
  //   return total;
  // };

  const AddQuantity = (val) => {
    let array = storeData;
    val.quantity += 1;
    // duplicate add lai euta data ma data ko number add vaos not item name
    let findingIndex = storeData?.findIndex((x) => x.name === val.name);
    if (findingIndex > -1) {
      let newArray = storeData;
      val.total = Number(newArray[findingIndex].price) * val.quantity;
    }
    setStoreData([...array]);
  };
  const SubtractQuantity = (val) => {
    let array = storeData;

    let findingIndex = storeData?.findIndex((x) => x.name === val.name);
    if (findingIndex > -1 && val.quantity > 1) {
      val.quantity -= 1;
      let newArray = storeData;
      val.total = Number(newArray[findingIndex].total) - val.price;
    }
    setStoreData([...array]);
  };
  // const Edit = (i) => {
  //   let removeItems = storeData;
  //   removeItems.splice(i);
  //   setStoreData([...removeItems]);
  //   setMessage(false);
  // };
  const DeleteItems = (i) => {
    let removeItems = storeData;
    removeItems.splice(i, 1);
    setStoreData([...removeItems]);
    setMessage(false);

    // console.log(idStore);
    // axios
    //   .delete(`/booking/${idStore}`)
    //   .then((res) => {
    //     if (res.status === 200) {
    //       setMessage(false);
    //       getData(idStore);
    //       toast.error("Data has been deleted sucessfully");
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };
  const Conformation = (id) => {
    setMessage(true);
    setIdStore(id);
    // console.log(id);
  };

  let ConformationMessage;
  if (message) {
    ConformationMessage = (
      <MasterDeleteModal
        // id={idStore}
        Delete={DeleteItems}
        setMessage={setMessage}
      />
    );
  }
  const RedirectToPayment = () => {
    navigate(`/prodectopay`, {
      state: { storeData: storeData, names: billingFormData },
    });
  };
  return (
    <div>
      {storeData?.length > 0 ? (
        <div className="mt-6 mb-3  w-11/12 mx-auto tablet:w-full tablet:mx-0">
          <Table Head={Thead} height="billing">
            {storeData?.map((val, i) => {
              return (
                <tr key={i} className="border-b">
                  <td align="center">
                    <div className=" p-2.5 border-gray-300">{i + 1}</div>
                  </td>
                  <td align="center">
                    <div className=" p-2.5 capitalize border-gray-300">
                      {val.product_name}
                    </div>
                  </td>

                  <td align="center ">
                    <div className=" p-2.5 border-gray-300 flex justify-center items-center gap-4">
                      <div
                        className="bg-gray-300 rounded-[3px] p-1.5 shadow-xl shadow-[#bab9b9] cursor-pointer font-bold"
                        onClick={() => SubtractQuantity(val)}
                      >
                        <BiMinus />
                      </div>
                      <div> {val.quantity}</div>
                      <div
                        className="bg-gray-300 rounded-[3px] p-1.5 shadow-xl shadow-[#bab9b9] cursor-pointer font-bold "
                        onClick={() => AddQuantity(val)}
                      >
                        <BiPlus />
                      </div>
                    </div>
                  </td>
                  <td align="center ">
                    <select className=" w-24 p-2 bg-gray-300 border-none outline-none">
                      {val.priceandunit.map((items, index) => {
                        return <option key={index}>{items.unit}</option>;
                      })}
                    </select>
                  </td>
                  <td align="center">
                    <div className=" p-2.5 border-gray-300">
                      {(val.price = "7")}
                    </div>
                  </td>
                  <td align="center">
                    <div className=" p-4  border-gray-300">{val.total}</div>
                  </td>
                  <td align="center">
                    <div
                      className=" p-2.5 flex gap-3 items-center 
                     border-gray-300 "
                    >
                      <div
                        className="px-1.5 py-1 border hover:bg-red-500 hover:text-white  rounded-[3px]  cursor-pointer"
                        onClick={() => Conformation(i)}
                      >
                        <MdDelete />
                      </div>

                      {ConformationMessage}
                    </div>
                  </td>
                </tr>
              );
            })}

            {/* <div onClick={() => Edit()}>CLEAR ALL</div> */}
          </Table>
        </div>
      ) : (
        <div className="">
          <Table Head={Thead}></Table>
          <div className="text-xl text-gray-500 flex   justify-center items-center  h-[292px]">
            No items available yet!
          </div>
        </div>
      )}
      <div className="capitalize font-semibold text-lg laptop:px-9   w-11/12 laptop:w-full flex  items-center  py-1 justify-end  ">
        <div className="text-gray-700">total price= </div>
        <div className="text-gray-800"> rs {TotalPrice()}</div>
      </div>
      {/* <form className="laptop:flex  mt-7 justify-center ">
        <div className="capitalize   w-11/12 laptop:w-full laptop:mr-4 flex justify-end  my-2">
          <div className="w-fit   flex  items-center gap-1.5">
            <div className="text-gray-500  font-semibold ">
              discount price={" "}
            </div>
            <div>
              {" "}
              <input
                type="text"
                placeholder="Discount Amount"
                className="border bg-sky-50 my-0.5 w-48  px-2 py-0.5"
              />
            </div>
          </div>
        </div>

        <div className="capitalize  w-11/12 laptop:w-full laptop:ml-4 flex justify-end my-2 ">
          <div className="w-fit  flex items-center gap-1.5">
            <div className="text-gray-500 font-semibold ">VAT = </div>
            <div className="text-gray-700">
              <input
                type="text"
                placeholder="VAT Amount"
                className="border bg-sky-50 my-0.5  px-2 py-0.5 w-48"
              />
            </div>
          </div>
        </div>
      </form> */}
      {/* <div className="capitalize font-semibold   flex justify-end w-11/12 my-5 ">
        <div className=" w-fit  flex gap-1.5">
          <div className="text-gray-500">total amount = </div>
          <div className="text-gray-700"> rs.60</div>
        </div>
      </div> */}
      <div className="flex justify-end  w-11/12">
        <button
          type="submit"
          // onClick={}
          className="bg-green-600 text-white  font-bold capitalize px-5 py-2 rounded-md hover:bg-opacity-70 "
          disabled={storeData.length < 1}
        >
          proceed to pay
        </button>
      </div>
    </div>
  );
}

export default BillingTable;
